import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeftOutlined } from "@ant-design/icons";
import "./PageHeader.css";

function PageHeader({ title, children, hasBackButton = false }) {
  const navigate = useNavigate();

  const handleBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate("/");
    }
  };

  return (
    <div className="pageheader-header">
      <div className="pageheader-left">
        {hasBackButton && (
          <ArrowLeftOutlined
            className="pageheader-back-btn"
            onClick={handleBack}
          />
        )}
        <h2 className="pageheader-title">{title}</h2>
      </div>

      <div className="pageheader-actions">{children}</div>
    </div>
  );
}

export default PageHeader;
